function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n    "));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28,8h2V4a2.0021,2.0021,0,0,0-2-2H24V4h4Z",
  transform: "translate(0 0)"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 17,
  y: 2,
  width: 4,
  height: 2
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 11,
  width: 2,
  height: 4
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28,18v4H24V10a2.0023,2.0023,0,0,0-2-2H10V4h4V2H10A2.0023,2.0023,0,0,0,8,4V8H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24h4a2.0023,2.0023,0,0,0,2-2V18ZM22,28H4V10H22Z",
  transform: "translate(0 0)"
});
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  id: "_Transparent_Rectangle_",
  "data-name": "<Transparent Rectangle>",
  className: "cls-1",
  width: 32,
  height: 32
});
const SvgReplicate = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "icon",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReplicate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/replicate.3b829fcc.svg";
export { ForwardRef as ReactComponent };